import { createFileRoute } from "@tanstack/react-router";
import { StubAdminPage } from "@/components/admin/StubAdminPage";
import { Webhook } from "lucide-react";

export const Route = createFileRoute("/admin/event-logs")({
  component: () => (
    <StubAdminPage
      icon={Webhook}
      title="Event logs"
      subtitle="Webhook deliveries and audit events"
    />
  ),
});
